// 其他异常

import axios from 'axios'
import QS from 'qs'
import { Message } from 'element-ui'
import store from '@/store/index'
import router from '../router'
import CryptoJS from 'crypto-js/crypto-js'
import * as COOKIE from '@/assets/js/cookie.js'
const SUCCESS = 10000 // 请求成功
const UNKNOW_ERR = 20000 // 服务暂不可用
const INVALID_USERNAME = 20001 // 无效的用户名
const INVALID_SIGN = 20002 // 无效的签名
const INVALID_TIMESTAMP = 20004 // 无效的请求时间
const PARAM_ERR = 30000 // 参数错误
const SERVICE_ERR = 40000 // 业务异常，请联系客服
const OTHER_ERR = 50000
var baseURL = []
axios.defaults.timeout = 10000
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8;' // 配置请求头application/x-www-form-urlencoded;

/* 环境的切换 */
if (process.env.NODE_ENV == 'development') {
  // 开发
  // console.log('开发模式')
  axios.defaults.baseURL = ''
  baseURL = [
    'https://business-test.hebooming.com'
    // 'https://gateway-student.hebooming.com:8083'
    // 'https://takeout-aauod.hebooming.com:8082'
  ]
} else if (process.env.NODE_ENV == 'debug') {
  // 测试
  // console.log('测试模式')
  axios.defaults.baseURL = 'http://localhost:8084/'
} else if (process.env.NODE_ENV == 'production') {
  // 生产
  // console.log('生产模式')
  axios.defaults.baseURL = ''
  baseURL = ['https://takeout-aauod.hebooming.com:8082']
  // baseURL = ['https://gateway-student.hebooming.com:8083']
  // baseURL = ['https://business-test.hebooming.com']
}
axios.defaults.withCredentials = false

// 请求拦截器
axios.interceptors.request.use(
  config => {
    // 每次发送请求之前判断是否存在token，如果存在，则统一在http请求的header都加上token，不用每次请求都手动添加了
    // 即使本地存在token，也有可能token是过期的，所以在响应拦截器中要对返回状态进行判断
    const token = COOKIE.getCookie('token')
    if (token) {
      // console.log('token==================', token)
      config.headers['Authorization'] = 'Bearer ' + token // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    // token && (config.headers.Authorization = token)

    if (config.method === 'post') {
      // config.data = QS.stringify(config.data)
    }
    return config
  },
  error => {
    return Promise.error(error)
  }
)

// 响应拦截器
axios.interceptors.response.use(
  response => {
    // console.log('响应拦截器', response.data)

    if (response.data.code) {
      return Promise.resolve(response.data)
    } else {
      return Promise.resolve(response)
    }

    if (response.status === 200) {
      if (response.config.url.indexOf('/export') > -1) {
        if (response.data.code) {
          return Promise.reject(response.data)
        } else {
          return Promise.resolve(response.data)
        }
      }
      // //console.log(200, response);
      Promise.reject(response)
      switch (response.data.code) {
        case SUCCESS:
          return Promise.resolve(response.data)
        case UNKNOW_ERR:
          errMsg(response.data.message ? response.data.message : '服务暂不可用')
          return Promise.reject(response)
        case INVALID_USERNAME:
          errMsg(response.data.message ? response.data.message : '无效的用户名')
          return Promise.reject(response)
        case INVALID_SIGN:
          errMsg(response.data.message ? response.data.message : '无效的签名')
          return Promise.reject(response)

        case INVALID_TIMESTAMP:
          errMsg(response.data.message ? response.data.message : '无效的请求时间')
          return Promise.reject(response)
        case PARAM_ERR:
          errMsg(response.data.message ? response.data.message : '参数错误')
          return Promise.reject(response)
        case SERVICE_ERR:
          errMsg(response.data.message ? response.data.message : '业务异常，请联系客服')
          return Promise.reject(response)
        case OTHER_ERR:
          errMsg(response.data.message ? response.data.message : '其他异常')
          return Promise.reject(response)
        default:
          errMsg(response.data.message ? response.data.message : '未知错误')
          return Promise.reject(response)
      }
    } else {
      return Promise.reject(response)
    }
    // }
  },
  // 服务器状态码不是200的情况
  error => {
    // //console.log('错误:', error.response.status)
    if (error.response.status) {
      switch (error.response.status) {
        // 401: 未登录
        // 未登录则跳转登录页面，并携带当前页面的路径
        // 在登录成功后返回当前页面，这一步需要在登录页操作。
        case 401:
          // console.log('@@@@@@@@@@@@@@@@@@@@', store.state.system.hasLogin)
          if (store.state.system.hasLogin) {
            router.replace({
              path: '/login',
              query: {
                redirect: router.currentRoute.fullPath
              }
            })
            store.commit('system/logout')
          }

          break
        // 403 token过期
        // 登录过期对用户进行提示
        // 清除本地token和清空vuex中token对象
        // 跳转登录页面
        case 403:
          if (store.state.system.hasLogin) {
            Message({
              message: '登录过期，请重新登录',
              duration: 1000,
              type: 'warning',
              forbidClick: true
            })
            // 跳转登录页面，并将要浏览的页面fullPath传过去，登录成功后跳转需要访问的页面
            setTimeout(() => {
              router.replace({
                path: '/login',
                query: {
                  redirect: router.currentRoute.fullPath
                }
              })
            }, 1000)
            store.commit('system/logout')
          }

          break
        // 404请求不存在
        case 404:
          Message({
            message: '网络请求不存在',
            type: 'warning',
            duration: 1500,
            forbidClick: true
          })
          break
        // 500请求不存在
        case 500:
          Message({
            message: error.response.data.message,
            type: 'warning',
            duration: 2000,
            forbidClick: true
          })
          break
        // 其他错误，直接抛出错误提示
        default:
          Message({
            message: error.response.data.message,
            duration: 1500,
            type: 'warning',
            forbidClick: true
          })
      }

      return Promise.reject(error.response)
    }
  }
)
// 生成令牌
const createSign = (stringSign, key) => {
  // //console.log('createSign', key);
  let hash = CryptoJS.HmacSHA256(axios.defaults.baseURL + stringSign + '&key=' + key, key)
  let hashInHex = CryptoJS.enc.Hex.stringify(hash).toUpperCase()
  // //console.log('sign', hashInHex);
  return hashInHex
}
// 生成请求路径
const createURL = (api, params, url, method) => {
  let _url = ''
  if (typeof url === 'string' && url.padStart('http')) {
    _url = url + api
  } else {
    var i = url || 0
    _url = (baseURL[i] || baseURL[0]) + api
  }

  var formatUrlRes = formatUrl(method, _url, params)
  let timestamp = Date.parse(new Date())
  // let username = COOKIE.getCookie('username')
  // let key = COOKIE.getCookie('key')
  let username = COOKIE.getCookie('username')
  let URL
  let _params = {}
  for (let item in params) {
    if (formatUrlRes.params.indexOf(item) == -1) {
      _params[item] = params[item]
    }
  }
  if (method == 'GET' || method == 'DELETE' || method == 'get') {
    if (timestamp) {
      _params.timestamp = timestamp
    }
    if (username) {
      _params.username = username
    }

    // 请求地址增加设备类型  20221222 于洋
    URL = formatUrlRes.url + '?' + QS.stringify(_params) + '&deviceType=PC'
  } else {
    let p = {}
    if (timestamp) {
      p.timestamp = timestamp
    }
    if (username) {
      p.username = username
    }
    URL = formatUrlRes.url + '?' + QS.stringify(p) + '&deviceType=PC'
  }
  // let sign = createSign(URL, key)
  // //console.log('$$$$$$$$$$$$$$$$$$$$$$$$$$$$', URL)
  // URL += '&sign=' + sign

  return method == 'GET' || method == 'GETNEW' || method == 'DELETE' || method == 'DELETEBODY' || method == 'DELETEBODYNEW'
    ? URL
    : { url: URL, data: _params }
}

// 格式化url替换路径参数
const formatUrl = (method, url, p) => {
  // console.log('method', method)
  // console.log('url', url)
  // console.log('p', p)
  let _url = url
  // let reg = /(?<=\{)[^}]*(?=\})/g
  let reg = /(\{)[^}]*(\})/g
  // let reg = /\{(.+?)\}/g
  let params = url.match(reg) || []
  // console.log('params', params)
  for (let i = 0; i < params.length; i++) {
    params[i] = params[i].substring(1, params[i].length - 1)
  }
  // console.log('params2', params)
  if (params && params.length > 0) {
    for (let item of params) {
      _url = _url.replace('{' + item + '}', p[item])
      if (p[item] == undefined) {
        console.error(method, url, ' 路径参数{' + item + '}未定义')
      }
      // console.log('_url', _url)
    }
    return { url: _url, params: params || [] }
  } else {
    return { url: url, params: params || [] }
  }
}

/**
 * GETNEW方法，对应get请求
 * @param {String}  api [请求的业务api ]
 * @param {String|Number} url [请求的url固定路径或者基础路径baseURL的index]
 * @param {Object} params [请求时携带的参数]
 */
export function GETNEW(api, params, url) {
  let _url = createURL(api, params, url, 'GET')
  // console.log('get-----url', _url)
  // //console.log('url', _url)
  return new Promise((resolve, reject) => {
    axios
      .get(_url)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

export function POSTNEW(api, params, url, timeout) {
  let createURLRes = createURL(api, params, url, 'POSTNEW')
  var timeout = timeout || 10000
  return new Promise((resolve, reject) => {
    axios
      .post(createURLRes.url, createURLRes.data, { timeout: timeout })
      .then(res => {
        // console.log(res, 'axios')
        resolve(res)
      })
      .catch(err => {
        // console.log(err, 'axios err')
        reject(err.data)
      })
  })
}

export function PUTNEW(api, params, url) {
  let createURLRes = createURL(api, params, url, 'POST')
  var timeout = timeout || 10000
  return new Promise((resolve, reject) => {
    axios
      .put(createURLRes.url, createURLRes.data, { timeout: timeout })
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}
export function DELETENEW(api, params, url) {
  let _url = createURL(api, params, url, 'DELETE')
  return new Promise((resolve, reject) => {
    axios
      .delete(_url)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

export function DELETEBODYNEW(api, params, url) {
  let _url = createURL(api, params, url, 'DELETEBODYNEW')
  return new Promise((resolve, reject) => {
    axios
      .delete(_url, { data: params })
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err.data)
      })
  })
}

/**
 * post方法，对应post请求 formData
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function POSTFormDataNEW(api, params, url) {
  axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;'

  let createURLRes = createURL(api, params, url, 'POST')
  return new Promise((resolve, reject) => {
    axios
      .post(createURLRes.url, params, { timeout: 300000 })
      .then(res => {
        resolve(res.data)
      })
      .catch(err => {
        reject(err.data)
      })
  })
}

export function POSTFormDataImport(api, params, url) {
  axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;'

  let createURLRes = createURL(api, params, url, 'POST')
  return new Promise((resolve, reject) => {
    axios
      .post(createURLRes.url, params, { timeout: 300000 })
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}
/**
 * 下载文件
 */
export function download(api, params, url) {
  let _url = createURL(api, params, url, 'GET')
  console.log(_url, '下载url')
  window.location.href = _url
}
/**
 * 上传文件
 */
export function UPLOADINGNEW(api, params, url) {
  axios.defaults.headers.post['Content-Type'] = 'multipart/form-data;charset=UTF-8;'

  let createURLRes = createURL(api, params, url, 'POST')
  return new Promise((resolve, reject) => {
    axios
      .post(createURLRes.url, createURLRes.data, { timeout: 300000 })
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}
/**
 * 导出文件
 */
export function EXPORTNEW(api, params, url, method = 'post') {
  // axios.defaults.headers.post['Content-Type'] = 'multipart/form-data;charset=UTF-8;'

  let createURLRes = createURL(api, params, url, method)
  return new Promise((resolve, reject) => {
    axios[method](createURLRes.url, createURLRes.data, { timeout: 1000 * 60 * 10, responseType: 'arraybuffer' })
      .then(res => {
        // //console.log('导出文件成功', res)
        resolve(res)
      })
      .catch(err => {
        // //console.log('导出文件失败', err)
        reject(err)
      })
  })
}

/**
 * 上传图片
 */
export function uploadingImg(url, params, i) {
  axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8;'
  var i = i || 0
  var url = (baseURL[i] || baseURL[0]) + url
  let paramsa = new FormData()
  paramsa.append('file', params.file)
  return new Promise((resolve, reject) => {
    axios
      .post(url, paramsa, { headers: { 'Content-Type': 'application/json;charset=UTF-8;', timeout: 300000 } })
      .then(res => {
        resolve(res.data)
      })
      .catch(err => {
        reject(err.data)
      })
  })
}
/**
 * 导出文件
 */
export function EXPORTNEW1(api, params, url, method = 'post') {
  axios.defaults.headers[method]['Content-Type'] = 'application/vnd.ms-excel;'

  let createURLRes = createURL(api, params, url, method)
  return new Promise((resolve, reject) => {
    axios[method](createURLRes.url)
      .then(res => {
        console.log('导出文件成功', res)
        resolve(res)
      })
      .catch(err => {
        console.log('导出文件失败', err)
        reject(err)
      })
  })
}

/**
 * 因服务端接口返回值结构变化弃用以下方法
 */
export function GET(api, params, url) {
  let _url = createURL(api, params, url, 'GET')
  return new Promise((resolve, reject) => {
    axios
      .get(_url)
      .then(res => {
        resolve(res.data)
      })
      .catch(err => {
        reject(err.data)
      })
  })
}
export function PUT(api, params, url) {
  let createURLRes = createURL(api, params, url, 'POST')
  var timeout = timeout || 10000
  return new Promise((resolve, reject) => {
    axios
      .put(createURLRes.url, createURLRes.data, { timeout: timeout })
      .then(res => {
        resolve(res.data)
      })
      .catch(err => {
        reject(err.data)
      })
  })
}

// 弃用
export function POST(api, params, url, timeout) {
  let createURLRes = createURL(api, params, url, 'POST')
  var timeout = timeout || 10000
  return new Promise((resolve, reject) => {
    axios
      .post(createURLRes.url, createURLRes.data, { timeout: timeout })
      .then(res => {
        // console.log(res, 'axios')
        if (res.data) {
          resolve(res.data)
        } else {
          resolve(res)
        }
      })
      .catch(err => {
        // console.log(err, 'axios err')
        reject(err.data)
      })
  })
}
// 弃用
export function DELETE(api, params, url) {
  let _url = createURL(api, params, url, 'DELETE')
  return new Promise((resolve, reject) => {
    axios
      .delete(_url)
      .then(res => {
        resolve(res.data)
      })
      .catch(err => {
        reject(err.data)
      })
  })
}

export function DELETEBODY(api, params, url) {
  let _url = createURL(api, params, url, 'DELETEBODY')
  return new Promise((resolve, reject) => {
    axios
      .delete(_url, { data: params })
      .then(res => {
        resolve(res.data)
      })
      .catch(err => {
        reject(err.data)
      })
  })
}
export function POSTFormData(api, params, url) {
  axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;'

  let createURLRes = createURL(api, params, url, 'POST')
  return new Promise((resolve, reject) => {
    axios
      .post(createURLRes.url, params, { timeout: 600000 })
      .then(res => {
        resolve(res.data)
      })
      .catch(err => {
        reject(err.data)
      })
  })
}

export function uploading(api, params, url) {
  axios.defaults.headers.post['Content-Type'] = 'multipart/form-data;charset=UTF-8;'

  let createURLRes = createURL(api, params, url, 'POST')
  return new Promise((resolve, reject) => {
    axios
      .post(createURLRes.url, createURLRes.data, { timeout: 300000 })
      .then(res => {
        resolve(res.data)
      })
      .catch(err => {
        reject(err.data)
      })
  })
}
export function EXPORT(api, params, url, method = 'post') {
  // axios.defaults.headers.post['Content-Type'] = 'multipart/form-data;charset=UTF-8;'

  let createURLRes = createURL(api, params, url, method)
  return new Promise((resolve, reject) => {
    axios[method](createURLRes.url, createURLRes.data, { timeout: 1000 * 60 * 10, responseType: 'arraybuffer' })
      .then(res => {
        console.log('导出文件成功', res)
        console.log(res, '文件')
        resolve(res.data)
      })
      .catch(err => {
        // //console.log('导出文件失败', err)
        reject(err.data)
      })
  })
}

var errMsg = function(msg) {
  Message({
    message: msg,
    duration: 1500,
    type: 'warning',
    forbidClick: true
  })
}



// WEBPACK FOOTER //
// ./src/request/http.js